import { Component, OnInit } from '@angular/core';
import { TransportUnitDto } from '../../../interfaces/Dtos/TransportUnitDto';
import { TransporUnitService } from './services/transpor-unit.service';

@Component({
  selector: 'neoris-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.css']
})
export class VehicleComponent implements OnInit {

  page: number
  sizePagination: number = 10
  transportUniListFilter: TransportUnitDto[]
  transportUniListFilterShow: TransportUnitDto[]

  constructor(
    private transporUnitService: TransporUnitService) { }

  ngOnInit() {
    
    this.LoadData()
  }

  LoadData() {
    this.transporUnitService.GetTranposUnit().subscribe((r) => {
      this.transportUniListFilter = r.data
      this.transportUniListFilterShow = this.transportUniListFilter
    })
  }

  EditClient(tu: TransportUnitDto) {
    console.log(tu)
  }

  DeleteClient(tu: TransportUnitDto) {
  }

  onSearchChange(searchValue: string): void {
    this.transportUniListFilterShow = []
    this.transportUniListFilterShow = this.transportUniListFilter
      .filter(c => (c.code.toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
        || c.code?.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        || c.plate?.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        || c.number?.toString().toLowerCase().indexOf(searchValue.toLowerCase()) > -1)
  }

}
